var _rect, _circle, _circle2, _circle3, _circle4, _line, _circle5, _path, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoComcolorsChatbot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 14,
    width: 24,
    height: 20,
    rx: 4,
    fill: "white",
    stroke: "url(#colorGradient)",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "colorGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#006ab3",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    style: {
      stopColor: "#358e2e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    style: {
      stopColor: "#fcc51d",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    style: {
      stopColor: "#f29400",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    style: {
      stopColor: "#e2001a",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#a663a1",
      stopOpacity: 1
    }
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 22,
    r: 2.5,
    fill: "#006ab3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 21,
    r: 0.8,
    fill: "white",
    opacity: 0.7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 22,
    r: 2.5,
    fill: "#006ab3"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 21,
    r: 0.8,
    fill: "white",
    opacity: 0.7
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 14,
    x2: 24,
    y2: 8,
    stroke: "url(#colorGradient)",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 6,
    r: 2,
    fill: "#f29400"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 27 Q24 29 29 27",
    stroke: "#006ab3",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 36,
    r: 1.5,
    fill: "#e2001a"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 36,
    r: 1.5,
    fill: "#358e2e"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 36,
    r: 1.5,
    fill: "#fcc51d"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 18,
    r: 2,
    fill: "#a663a1",
    opacity: 0.9
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 24,
    r: 2,
    fill: "#f29400",
    opacity: 0.8
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 30,
    r: 2,
    fill: "#358e2e",
    opacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoComcolorsChatbot);
export default __webpack_public_path__ + "static/media/logo-comcolors-chatbot.c8c4f7f92c10dff09d3764b0ddbe6198.svg";
export { ForwardRef as ReactComponent };